import EbayAuCalculator from '@/tools/ebayAuCalculator.vue';
import { mountVueTool } from './shared/mountVueTool';

mountVueTool(EbayAuCalculator, 'ebayAuCalculator');
